import { render, staticRenderFns } from "./CityDetail.vue?vue&type=template&id=08088d1f&"
import script from "./CityDetail.vue?vue&type=script&lang=js&"
export * from "./CityDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports